import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=46120136"
import script from "./home-page.ts?vue&type=script&lang=ts&external"
export * from "./home-page.ts?vue&type=script&lang=ts&external"
import style0 from "./home-page.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports